import * as React from 'react';
import { useEffect, useState } from 'react';

import type { Event } from '@/types/article-type';
import fetchEvents from '@/utils/functions/wordpress/fetch-events';
import UpcomingEventsRight from '@/components/sections/right/upcoming-events';

type UpcomingEventsProps = {
    className?: string;
    initialEvents?: Event[];
};

const UpcomingEvents = (props: UpcomingEventsProps) => {
    const { className, initialEvents } = props;
    const [upcomingEvents, setUpcomingEvents] = useState<Event[]>(initialEvents || []);

    useEffect(() => {
        fetchEvents(2, true).then(fetchedEvents => fetchedEvents.length > 0 && setUpcomingEvents(fetchedEvents));
    }, []);

    return <UpcomingEventsRight className={className} title="Upcoming Events" events={upcomingEvents} />;
};

export default UpcomingEvents;
